import { ROUTE_CHECKOUT } from '../constants';
import { buildOrderPlacedPayload } from '../helpers/brazeHelper';
import { withItemsPayload } from './pulseItemsPayload';
import { trackImmediate } from './pulseTracker';
import type { PulseEventPartial } from './pulseSchema';
import { PULSE_VIEW_ID } from './pulseViewIds';
import {
  clearCheckoutIdSession,
  resolveCheckoutIdForPurchase,
} from './pulseCheckoutId';

export const buildPurchasePulsePartial = (
  orderId: string | number,
  order: any,
  isItMobile: boolean,
  page_path?: string
): PulseEventPartial => {
  const orderPlacedPayload = buildOrderPlacedPayload(orderId, order, isItMobile);
  const { pickUpMethod: _pickUpMethod, ...brazePayload } = orderPlacedPayload;

  const deliveryFee = Number(orderPlacedPayload.deliveryFee ?? 0);
  const serviceFee = Number(orderPlacedPayload.serviceFee ?? 0);
  const tipAmount = Number(orderPlacedPayload.tipAmount ?? 0);
  const transactionTotal =
    Number(orderPlacedPayload.total ?? 0) +
    (Number.isFinite(tipAmount) ? tipAmount : 0);
  const cartId = order?.cart_id ?? order?.cartId ?? null;
  const checkout_id = resolveCheckoutIdForPurchase(cartId);
  clearCheckoutIdSession();

  return {
    event_name: 'purchase',
    view_id: PULSE_VIEW_ID.CHECKOUT,
    page_path:
      page_path ??
      (typeof window !== 'undefined'
        ? window.location.pathname
        : ROUTE_CHECKOUT),
    conversion_id: orderId ?? null,
    cart_id: cartId,
    checkout_id,
    sub_total_amount: orderPlacedPayload.subtotal ?? null,
    tax_amount: orderPlacedPayload.tax ?? null,
    tip: tipAmount > 0 ? tipAmount : null,
    transaction_amount: transactionTotal > 0 ? transactionTotal : null,
    delivery_amount: deliveryFee > 0 ? deliveryFee : null,
    service_amount: serviceFee > 0 ? serviceFee : null,
    ...withItemsPayload(brazePayload),
    action: 'purchase',
  };
};

/** Pulse `purchase` — immediate send (not batched); fail → retry queue. */
export const trackPurchase = (
  orderId: string | number,
  order: any,
  isItMobile: boolean,
  page_path?: string
): void => {
  trackImmediate(
    buildPurchasePulsePartial(orderId, order, isItMobile, page_path)
  );
};
